import { optionsValues } from '@/vacancy_request/components/template-request-form/options-group/constants';

export const languageOptions = [
  { value: 'eng', label: 'Inglés' },
  { value: 'ale', label: 'Alemán' },
  { value: 'chi', label: 'Chino' },
  { value: 'cor', label: 'Coreano' },
  { value: 'esp', label: 'Español' },
  { value: 'fra', label: 'Francés' },
  { value: 'hol', label: 'Holandés' },
  { value: 'ita', label: 'Italiano' },
  { value: 'jap', label: 'Japonés' },
  { value: 'por', label: 'Portugués' },
  { value: 'que', label: 'Quechua' }
];

export const defaultOption = {
  language: languageOptions[0].value,
  option: optionsValues.DISABLED.toString()
};
